'use strict';

module Patersons {

    export class BulkDownloadService {

        q: ng.IQService;
        http: ng.IHttpService;
        window: any;

        static $inject = ['$q', '$window', '$http'];

        constructor($q, $window, $http) {
            this.q = $q;
            this.http = $http;
            this.window = $window;
        }

        downloadItems = function(items: any[], zipFilename: string) : ng.IPromise<any> {
            let zip = new JSZip();
            let http = this.http;
            let window = this.window;

            var fileDownloads = [];
            angular.forEach(items, function (item) {
                fileDownloads.push(
                    http.get(item.uri, { responseType: 'arraybuffer' })
                        .then(result => {
                            let filename = item.name;

                            // If the item has a pretty filename then use it as the filename
                            if (item.prettyFileName && item.prettyFileName !== '') {
                                filename = item.prettyFileName
                            }

                            console.info('Zipping ' + filename);
                            zip.file(filename, result.data, { binary: true });
                        })
                        .catch(response => {
                            console.error('Error downloading file from ' + item.uri, response.status, response.data);
                        }));
            });

            let deferred = this.q.defer();

            return this.q.all(fileDownloads)
                .then(() => {
                    console.info('Generating zip file');
                    zip.generateAsync({ type: "blob" })
                        .then(blob => {
                            window.saveAs(blob, zipFilename);

                            deferred.resolve();

                            return deferred.promise;
                        })
                        .catch(response => {
                            console.error('Error saving zip file', response.status, response.data);

                            deferred.reject(response);

                            return deferred.promise;
                        })
                });
        }
    }
}